/* ===== Nova Minimal — global.js v2 ===== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  /* -------------------------------------------------
   * Formato de moneda (soporta TODOS los formatos de Shopify:
   * COP, CLP, EUR, etc. — no solo el de dos decimales)
   * ------------------------------------------------- */
  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var fmt = format || theme.moneyFormat || '${{amount}}';
    var match = fmt.match(PLACEHOLDER);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return fmt.replace(PLACEHOLDER, value);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  window.themeUtils = { formatMoney: formatMoney };

  /* -------------------------------------------------
   * Altura real del header -> variable CSS
   * ------------------------------------------------- */
  function measureHeader() {
    var header = document.querySelector('.header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  /* -------------------------------------------------
   * Menú móvil accesible
   * ------------------------------------------------- */
  function initMenu() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-menu-toggle]');
      var header = document.querySelector('[data-header]');
      if (!header) return;

      if (toggle) {
        var open = header.classList.toggle('header--open');
        document.body.classList.toggle('menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (header.classList.contains('header--open') && !e.target.closest('.header__menu')) {
        header.classList.remove('header--open');
        document.body.classList.remove('menu-open');
        var t = header.querySelector('[data-menu-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var header = document.querySelector('.header--open');
      if (!header) return;
      header.classList.remove('header--open');
      document.body.classList.remove('menu-open');
      var t = header.querySelector('[data-menu-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  }

  /* -------------------------------------------------
   * Selectores de cantidad
   * ------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var wrap = btn.closest('.quantity');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var val = parseInt(input.value, 10) || min;
      val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
      if (val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* -------------------------------------------------
   * Galería de producto
   * ------------------------------------------------- */
  function setGalleryImage(gallery, src, alt, mediaId) {
    var main = gallery.querySelector('[data-main-image]');
    if (!main || !src) return;
    main.src = src;
    main.removeAttribute('srcset');
    if (alt != null) main.alt = alt;
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      var isCurrent = mediaId
        ? t.getAttribute('data-media-id') === String(mediaId)
        : t.getAttribute('data-full') === src;
      t.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  function initGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var gallery = thumb.closest('[data-gallery]');
      if (!gallery) return;
      var img = thumb.querySelector('img');
      setGalleryImage(
        gallery,
        thumb.getAttribute('data-full'),
        img ? img.alt : '',
        thumb.getAttribute('data-media-id')
      );
    });
  }

  /* -------------------------------------------------
   * Variantes de producto
   * ------------------------------------------------- */
  function priceMarkup(variant) {
    var html = '';
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    html += '<span class="price' + (onSale ? ' price--on-sale' : '') + '">';
    if (onSale) {
      html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
      html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
      var off = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      if (off > 0) html += '<span class="price__off">-' + off + '%</span>';
    } else {
      html += formatMoney(variant.price);
    }
    html += '</span>';
    return html;
  }

  function initProductForm(form) {
    if (form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var section = form.closest('[data-product-section]') || document;
    // Los <select> se asocian al form con el atributo form="..." y viven fuera de él
    var selects = Array.prototype.slice.call(section.querySelectorAll('[data-option]'));
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-current-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    var inventoryEl = section.querySelector('[data-inventory]');
    var skuEl = section.querySelector('[data-sku]');
    var gallery = section.querySelector('[data-gallery]');

    function chosen() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant() {
      var picked = chosen();
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === picked[i]; });
      })[0];
    }

    function refreshOptionAvailability() {
      var picked = chosen();
      selects.forEach(function (select, index) {
        Array.prototype.slice.call(select.options).forEach(function (option) {
          var test = picked.slice();
          test[index] = option.value;
          var reachable = variants.some(function (v) {
            for (var k = 0; k <= index; k++) {
              if (v.options[k] !== test[k]) return false;
            }
            return v.available;
          });
          var label = option.getAttribute('data-label') || option.value;
          option.setAttribute('data-unavailable', reachable ? 'false' : 'true');
          option.textContent = reachable ? label : label + ' — ' + (strings.soldOut || 'Agotado');
        });
      });
    }

    function setButtonState(button, variant) {
      if (!button) return;
      var text;
      if (!variant) text = button.getAttribute('data-unavailable-text') || 'No disponible';
      else if (!variant.available) text = button.getAttribute('data-sold-text') || 'Agotado';
      else text = button.getAttribute('data-add-text') || 'Agregar al carrito';
      button.disabled = !variant || !variant.available;
      var span = button.querySelector('[data-add-label]');
      (span || button).textContent = text;
    }

    function update(isUserAction) {
      var variant = findVariant();
      refreshOptionAvailability();

      setButtonState(addBtn, variant);
      setButtonState(stickyBtn, variant);

      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = priceMarkup(variant);
      if (stickyPrice) stickyPrice.innerHTML = priceMarkup(variant);
      if (skuEl) skuEl.textContent = variant.sku || '';

      if (inventoryEl) {
        inventoryEl.className = 'product__inventory';
        if (!variant.available) {
          inventoryEl.classList.add('product__inventory--out');
          inventoryEl.textContent = strings.soldOut || 'Agotado';
        } else if (variant.inventory_management && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0 && variant.inventory_quantity <= (theme.lowStockThreshold || 10)) {
          inventoryEl.classList.add('product__inventory--low');
          inventoryEl.textContent = (strings.lowStock || 'Quedan pocas unidades').replace('[count]', variant.inventory_quantity);
        } else {
          inventoryEl.classList.add('product__inventory--in');
          inventoryEl.textContent = strings.inStock || 'Disponible';
        }
      }

      if (gallery && variant.featured_image) {
        setGalleryImage(gallery, variant.featured_image, variant.featured_image_alt, variant.featured_media_id);
      }

      if (isUserAction && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', function () { update(true); });
    });

    // Estado inicial sin sobrescribir el precio ya renderizado por Liquid
    refreshOptionAvailability();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn);
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* -------------------------------------------------
   * Barra de compra fija en móvil
   * ------------------------------------------------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-product-sticky]');
    var anchor = document.querySelector('[data-add-button]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);
  }

  /* -------------------------------------------------
   * Carrito AJAX + drawer
   * ------------------------------------------------- */
  var drawer = null;
  var lastFocus = null;

  function sectionsToRequest() {
    var list = ['cart-drawer'];
    var cartSection = document.querySelector('[data-cart-section]');
    if (cartSection) list.push(cartSection.getAttribute('data-section-id'));
    return list.join(',');
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incoming = parsed.querySelector('[data-cart-replace]');
      if (!incoming) return;
      var target = document.querySelector('[data-cart-replace="' + incoming.getAttribute('data-cart-replace') + '"]');
      if (target) target.innerHTML = incoming.innerHTML;
    });
    syncCartCount();
  }

  function syncCartCount() {
    var source = document.querySelector('[data-cart-total-count]');
    if (!source) return;
    var count = parseInt(source.getAttribute('data-cart-total-count'), 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function openDrawer() {
    drawer = drawer || document.querySelector('[data-drawer]');
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-ready');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    drawer = drawer || document.querySelector('[data-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.classList.remove('is-ready');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-cart-error]');
    if (!box) return;
    box.innerHTML = escapeHtml(message);
    box.hidden = false;
  }

  function initCartAjax() {
    // Agregar al carrito
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || !theme.cartDrawer) return;
      e.preventDefault();

      var button = form.querySelector('[data-add-button]');
      var sticky = document.querySelector('[data-sticky-add]');
      var errorBox = form.querySelector('[data-cart-error]');
      if (errorBox) errorBox.hidden = true;
      if (button) button.classList.add('is-loading');
      if (sticky) sticky.classList.add('is-loading');

      var body = new FormData(form);
      body.append('sections', sectionsToRequest());
      body.append('sections_url', window.location.pathname);

      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            showFormError(form, res.data.description || res.data.message || (strings.cartError || 'No se pudo agregar el producto.'));
            return;
          }
          applySections(res.data.sections);
          openDrawer();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.data }));
        })
        .catch(function () {
          showFormError(form, strings.cartError || 'No se pudo agregar el producto.');
        })
        .finally(function () {
          if (button) button.classList.remove('is-loading');
          if (sticky) sticky.classList.remove('is-loading');
        });
    });

    // Cambiar cantidad / quitar línea
    function changeLine(key, quantity) {
      return fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionsToRequest(),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          applySections(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        });
    }

    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        changeLine(remove.getAttribute('data-cart-remove'), 0);
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-overlay]')) {
        closeDrawer();
        return;
      }
      if (e.target.closest('[data-drawer-open]')) {
        var opener = e.target.closest('[data-drawer-open]');
        if (theme.cartDrawer && document.querySelector('[data-drawer]')) {
          e.preventDefault();
          openDrawer();
        }
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-quantity]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeLine(input.getAttribute('data-cart-quantity'), qty);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* -------------------------------------------------
   * Boletín: mensaje de éxito accesible
   * ------------------------------------------------- */
  function focusFormResult() {
    var success = document.querySelector('[data-form-status]');
    if (success) success.focus();
  }

  /* -------------------------------------------------
   * Init
   * ------------------------------------------------- */
  function init() {
    measureHeader();
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    initStickyBar();
    syncCartCount();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initQuantity();
    initGallery();
    initCartAjax();
    init();
    focusFormResult();
  });

  window.addEventListener('resize', function () {
    measureHeader();
    if (window.innerWidth > 749) {
      var header = document.querySelector('[data-header]');
      if (header) header.classList.remove('header--open');
      document.body.classList.remove('menu-open');
      var toggle = document.querySelector('[data-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });
  window.addEventListener('pageshow', syncCartCount);

  // Personalizador de temas: re-inicializar al recargar secciones
  document.addEventListener('shopify:section:load', function () {
    drawer = null;
    init();
  });
  document.addEventListener('shopify:section:select', measureHeader);
})();
